/* @flow */
import * as React from 'react';
import { observer, inject } from 'mobx-react';
import { toJS } from 'mobx';
import Button from '@material-ui/core/Button';
import { translate } from 'react-i18next';

import type { TranslatorProps } from 'react-i18next';

import type TypeForm from 'forms/_.extend';

import ElectroCheckList from 'forms/components/inputs/ElectroCheckList/ElectroCheckList';

import ActionDrawerFormButtons from 'views/ActionDrawer/components/ActionDrawerFormButtons/ActionDrawerFormButtons';
import ActionDrawerBlock from 'views/ActionDrawer/components/ActionDrawerBlock/ActionDrawerBlock';
import ActionDrawerTable from 'views/ActionDrawer/components/ActionDrawerTable/ActionDrawerTable';

import styles from '../../../../ActionDrawer.module.scss';

import Loading from 'components/Loading/Loading';
import PageWrapper from 'components/PageWrapper/PageWrapper';

type TypeProps = {|
  form: TypeForm,
  account: Object,
|} & TranslatorProps;

@translate()
@inject('accountStore')
@observer
export default class AssignAccountForm extends React.Component<*> {
  componentDidMount() {
    const { accountStore }: { accountStore: Object } = this.props;
    const accountId: string = this.props.account.id;

    accountStore.loadUsers(accountId);
  }

  render(): React.Fragment {
    const { t, account, form, accountStore }: TypeProps = this.props;
    const { allUsersByAccount }: { allUsersByAccount: any } = accountStore;

    const details: Array<*> = [
      [t('general:trading_account'), account.name],
      [t('general:trading_accounts.labels.number'), account.account_no],
    ];

    if (accountStore.loadingUsers || !allUsersByAccount) {
      return <Loading />;
    }

    // Get all users assigned to that trading account (grouped by roles)
    // user, manager, account_admin, customer_executive, purchaser
    const allUsersByAccountArray: Array<Object> = toJS(allUsersByAccount);

    let excludeUsersArray: Array<Object> = [];

    for (const key: string in allUsersByAccountArray) {
      if (Object.prototype.hasOwnProperty.call(allUsersByAccountArray, key)) {
        excludeUsersArray = excludeUsersArray.concat(allUsersByAccountArray[key]);
      }
    }

    return (
      <React.Fragment>
        <div className={styles['action-drawer-content']}>
          <ActionDrawerBlock
            divider={true}
            gutters={true}
            heading={t('general:trading_accounts.labels.details')}
          >
            <ActionDrawerTable data={details} />
          </ActionDrawerBlock>
          <ElectroCheckList
            field={form.$('selectUser.users')}
            endpoint="users"
            placeholder={t('general:placeholders.first_last_name')}
            enableSearch={true}
            heading={t('general:actions.assign_trading_account_to')}
            searchKeys={['first_name', 'last_name']}
            exclude={excludeUsersArray.map((cc: Object) => cc.email)}
            valueKey="email"
            primaryLiteral={(item: Object) => `${item.first_name} ${item.last_name}`}
            secondaryLiteral={(item: Object) => (
              <React.Fragment>
                {t('general:roles.labels.current_role')}:{' '}
                <b>{t(`general:roles.${item.role_id}`)}</b>
              </React.Fragment>
            )}
            customResponse={(response: Object) => {
              let arr: Array<Object> = [];

              for (const key: string in response) {
                if (Object.prototype.hasOwnProperty.call(response, key)) {
                  arr = arr.concat(response[key]);
                }
              }

              return arr;
            }}
          />
        </div>
        <ActionDrawerFormButtons form={form} submitTxt={t('general:actions.assign_user_plural')} />
      </React.Fragment>
    );
  }
}
